import CryptoJS from "crypto-js";

const encryptedBase64Key = "bXVzdGJlODhieXRlc2tleQ==";
const parsedBase64Key = CryptoJS.enc.Base64.parse(encryptedBase64Key);

export const encoded = (plaintext) => {
  return CryptoJS.AES.encrypt(plaintext, parsedBase64Key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();
};

export const decoded = (encryptedText) => {
  return JSON.parse(
    CryptoJS.AES.decrypt(encryptedText, parsedBase64Key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    }).toString(CryptoJS.enc.Utf8)
  );
};

export const getSha = (password) => {
  var sha512 = require('js-sha512');
  sha512 = sha512(password);
  return sha512;
};

// Constants
export const toastConfig = {
  autoClose: 2000,
  hideProgressBar: true,
  removalReason: "timeout"
};